import { onBeforeUnmount, onMounted, ref } from "vue";

// Matches the `phone` SCSS mixin in assets/styles/_mixins.scss. Keep the two in
// step: this decides behaviour (which menu a tap opens, where toasts sit), the
// mixin decides layout, and they must flip at the same width.
export const PHONE_MAX_WIDTH = 767;

const PHONE_QUERY = `(max-width: ${PHONE_MAX_WIDTH}px)`;

// Defaults to false so the server render and the first client render agree;
// the real value lands on mount, before anything the user can tap.
export function useIsPhone() {
	const isPhone = ref(false);
	let query: MediaQueryList | null = null;

	const onChange = (event: MediaQueryListEvent | MediaQueryList) => {
		isPhone.value = event.matches;
	};

	onMounted(() => {
		query = window.matchMedia(PHONE_QUERY);
		onChange(query);
		query.addEventListener("change", onChange);
	});

	onBeforeUnmount(() => {
		query?.removeEventListener("change", onChange);
	});

	return isPhone;
}
